<div class="row align-top gutters">
  <div class="col-md-12">
    <div class="mat-elevation-z8">
      <table mat-table class="stripped-table" #ltModelTable [dataSource]="modelDataSource" #dataSort="matSort" matSort>

        <!-- Milestone Column -->
        <ng-container matColumnDef="milestone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Milestone </th>
          <td mat-cell *matCellDef="let row"> {{row.milestone}} </td>
        </ng-container>

        <!-- Scenario Column -->
        <ng-container matColumnDef="scenario">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Scenario </th>
          <td mat-cell *matCellDef="let row"> {{row.scenario}} </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="sentDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Sent Date </th>
          <td mat-cell *matCellDef="let row"> {{row.sentDateFormatted}} </td>
        </ng-container>

        <!-- Hard Debt Column -->
        <ng-container matColumnDef="hardDebt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Hard Debt </th>
          <td mat-cell *matCellDef="let row"> {{row.hardDebt}} </td>
        </ng-container>

        <!-- Lower Tier Yield Column -->
        <ng-container matColumnDef="lowerTierYield">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Lower Tier Yield </th>
          <td mat-cell *matCellDef="let row"> {{row.lowerTierYield}} </td>
        </ng-container>

        <!-- Lower Tier Equity Column -->
        <ng-container matColumnDef="lowerTierEquity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Lower Tier Equity </th>
          <td mat-cell *matCellDef="let row"> {{row.lowerTierEquity}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="modelColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: modelColumns;" [ngClass]="row.activeModel ? 'active-row' : ''"></tr>
      </table>
    </div>
    <div class="ltmodel-legend">
      <mat-icon>square</mat-icon><span class="legend-label">Current active model</span>
    </div>
  </div>
</div>
